import { ApiEndpoints } from 'models/api';
import { apiWithCore } from 'store/api';
import { ShortOption } from 'store';

export interface SurgeryVolumeItem {
	date: string;
	name: string;
	service_line: string;
	view_by_id: number;
	volume: number;
	fullDate: string;
}

export interface SurgeryVolumeResponse {
	volume_data: SurgeryVolumeItem[];
	group_by: string;
	latest_date: string;
	start_date: string;
	surgeon_procedure_data: {
		[key: number | string]: TopProcedureVolumeItem[];
	};
}

export interface VolumeRollupData {
	volume_values: {
		x: string | number;
		y: string | number;
	}[];
}

export interface SurgeryVolumeRollupResponse {
	data: VolumeRollupData[] | undefined;
}

export interface TopProcedureVolumeItem {
	avg_case_duration: number;
	procedure: string;
	service_line_avg_case_duration: number;
	std_case_time: number;
	volume: number;
	wheels_out_avg?: number;
	wheels_in_avg?: number;
	procedure_time_avg?: number;
}

export interface FilterParameters {
	facility_id: number | null;
	groupby: string;
	viewby?: string;
	filters: {
		surgeons: ShortOption[];
		days_of_week: string[];
		service_lines: ShortOption[];
		encounter_types?: ShortOption[];
		rooms: ShortOption[];
		procedures: string[];
		start_date: string;
		end_date: string;
		turnover_threshold?: number;
		compare_start_date?: string;
		compare_end_date?: string;
		primetime: string;
		add_ons: string;
	};
	label?: string;
}

/**
 * Provides endpoints for data values in database
 */
export const surgeryService = apiWithCore.injectEndpoints({
	endpoints: (build) => ({
		getSurgicalVolume: build.query<SurgeryVolumeResponse, FilterParameters>({
			query: (body) => ({
				url: ApiEndpoints.GET_SURGICAL_VOLUME,
				method: 'POST',
				body,
			}),
			providesTags: ['Core'],
		}),
		getSurgicalVolumeRollup: build.query<SurgeryVolumeRollupResponse, FilterParameters>({
			query: (body) => ({
				url: ApiEndpoints.GET_SURGICAL_VOLUME_ROLLUP,
				method: 'POST',
				body,
			}),
			providesTags: ['Core'],
		}),
	}),
});

export const { useGetSurgicalVolumeQuery, useGetSurgicalVolumeRollupQuery } = surgeryService;

export const {
	endpoints: { getSurgicalVolume, getSurgicalVolumeRollup },
} = surgeryService;
